export default class FixedNavigation {
	private links: NodeListOf<HTMLAnchorElement>;
	private readonly mastheadWrapper: HTMLDivElement;
	private readonly fixedNavigation: HTMLDivElement;

	constructor() {
		this.mastheadWrapper = document.querySelector('.masthead');
		this.fixedNavigation = document.querySelector('.fixed-navigation');

		if (this.mastheadWrapper && this.fixedNavigation) {
			this.links = this.fixedNavigation.querySelectorAll('a');
			window.addEventListener('scroll', () => this.onScroll(), { passive: true });
			this.onScroll();
		}
	}

	private onScroll(): void {
		const rect: DOMRect = this.mastheadWrapper.getBoundingClientRect();
		if (rect.height + rect.top > 0) {
			this.fixedNavigation.classList.remove('visible');
			this.fixedNavigation.setAttribute('aria-hidden', 'true');
			this.links.forEach((link: HTMLAnchorElement) => (link.tabIndex = -1));
		} else {
			this.fixedNavigation.classList.add('visible');
			this.fixedNavigation.setAttribute('aria-hidden', 'false');
			this.links.forEach((link: HTMLAnchorElement) => link.removeAttribute('tabindex'));
		}
	}
}
